import React from "react";
import "./FeaturesSection.css";

const features = [
  {
    title: "Enlace Personalizado",
    description:
      "Obtén un enlace único para compartir y registrar a tus referidos automáticamente.",
    icon: "🔗",
  },
  {
    title: "Comisiones Generosas",
    description:
      "Recibe el 10% por cada recarga, el 40% si tus referidos ganan y más beneficios de niveles inferiores.",
    icon: "💸",
  },
  {
    title: "Panel de Control",
    description:
      "Accede a estadísticas detalladas sobre tus referidos, ingresos y actividad en tiempo real.",
    icon: "📊",
  },
  {
    title: "Soporte Exclusivo",
    description:
      "Nuestro equipo está listo para asistirte en cada paso del proceso de ventas.",
    icon: "🤝",
  },
];

const FeaturesSection = () => {
  return (
    <section className="features">
      <h2 className="features-title">¿Por qué unirte al módulo de ventas?</h2>
      <p className="features-intro">
        Descubre las ventajas exclusivas que hemos diseñado para potenciar tus
        ingresos y facilitar tus procesos.
      </p>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
